/* ==========================================================================
   Hidecraft — product-form.js
   AJAX add to cart for the main product form (incl. sticky bar, gift wrap,
   personalisation line-item properties). Uses window.Hidecraft.cart (cart.js).
   ========================================================================== */

(() => {
  'use strict';

  class ProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.error = this.querySelector('[data-form-error]');
      this.form.addEventListener('submit', (event) => this.onSubmit(event));
    }

    buildBody() {
      const data = new FormData(this.form);
      const gift = document.querySelector(`input[data-gift-wrap][form="${this.form.id}"]:checked`);
      if (!gift) return data;

      // Gift wrap is a separate product: send both lines as JSON.
      const main = {
        id: Number(data.get('id')),
        quantity: Number(data.get('quantity') || 1),
        properties: {},
      };
      for (const [key, value] of data.entries()) {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && value) main.properties[match[1]] = value;
      }
      if (data.get('selling_plan')) main.selling_plan = data.get('selling_plan');
      return { items: [main, { id: Number(gift.dataset.giftWrap), quantity: 1 }] };
    }

    async onSubmit(event) {
      const cart = window.Hidecraft.cart;
      if (!cart) return; // falls back to a normal form post

      event.preventDefault();
      if (!this.form.reportValidity()) return;

      const idInput = this.form.querySelector('[name="id"]');
      if (!idInput || idInput.disabled || !idInput.value) return;

      const buttons = [event.submitter, this.form.querySelector('[type="submit"]')].filter(Boolean);
      buttons.forEach((button) => {
        button.classList.add('is-loading');
        button.setAttribute('aria-disabled', 'true');
      });
      if (this.error) this.error.hidden = true;

      try {
        await cart.add(this.buildBody());
        [...this.form.elements]
          .filter((el) => el.matches('[data-char-counter]'))
          .forEach((input) => {
            input.value = '';
            input.dispatchEvent(new Event('input', { bubbles: true }));
          });
      } catch (error) {
        if (this.error) {
          this.error.textContent = error.message;
          this.error.hidden = false;
        } else {
          window.Hidecraft.toast?.(error.message);
        }
      } finally {
        buttons.forEach((button) => {
          button.classList.remove('is-loading');
          button.removeAttribute('aria-disabled');
        });
      }
    }
  }

  customElements.define('product-form', ProductForm);
})();
